import React from 'react'
import { motion } from 'framer-motion'
import { StyleText, StyleTextWrapper, StyleTextWrapperAlternate } from './style'

interface IText {
  title: string
  subtitle?: string
  textWidth?: string
  rowGap?: string
  titleColor?: string
  subtitleColor?: string
}

// Create motion-enhanced versions of your styled components
const MotionTextWrapper = motion(StyleTextWrapper)
const MotionTextWrapperAlternate = motion(StyleTextWrapperAlternate)
const MotionText = motion(StyleText)

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
}

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
}

const TextWrapper = ({ title, subtitle, textWidth }: IText) => {
  return (
    <MotionTextWrapper
      align="center"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '0px 0px -50px 0px' }}
      variants={containerVariants}
    >
      <MotionText
        fontSize="32"
        align="center"
        color="primary"
        fontSizeSm="1.2"
        centered
        variants={textVariants}
      >
        {title}
      </MotionText>
      {subtitle && (
        <MotionText
          color="#000000"
          align="center"
          textWidth={textWidth}
          fontSize="16"
          weight="400"
          fontSizeSm="0.6"
          centered
          variants={textVariants}
        >
          {subtitle}
        </MotionText>
      )}
    </MotionTextWrapper>
  )
}

const TextWrapperAlternate = ({
  title,
  subtitle,
  textWidth,
  rowGap,
  titleColor,
  subtitleColor,
}: IText) => {
  return (
    <MotionTextWrapperAlternate
      rowGap={rowGap}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      <MotionText
        fontSize="24"
        color={titleColor || 'primary'}
        variants={textVariants}
      >
        {title}
      </MotionText>
      {subtitle && (
        <MotionText
          color={subtitleColor || '#000000'}
          textWidth={textWidth}
          fontSize="16"
          weight="400"
          variants={textVariants}
        >
          {subtitle}
        </MotionText>
      )}
    </MotionTextWrapperAlternate>
  )
}

export { TextWrapper, TextWrapperAlternate }
